import React from 'react';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import Calculator from './Calculator';


function LoginButton() {
  const { loginWithRedirect } = useAuth0();
  return <button onClick={() => loginWithRedirect()}>Log In</button>;
}

function LogoutButton() {
  const { logout } = useAuth0();
  return (
    <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
      Log Out
    </button>
  );
}

function Profile() {
  const { user, isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    isAuthenticated && (
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <img src={user.picture} alt={user.name} style={{ width: '40px', borderRadius: '50%' }} />
        <div>
          <div style={{ fontWeight: '600' }}>{user.name}</div>
          <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>{user.email}</div>
        </div>
      </div>
    )
  );
}

function AppContent() {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, user } = useAuth0();

  // Check if user email is from percepto.co domain
  React.useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      const emailDomain = user.email.split('@')[1].toLowerCase();
      if (emailDomain !== 'percepto.co') {
        logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        });
        alert('Access denied. Only @percepto.co email addresses are allowed.');
      }
    }
  }, [isLoading, isAuthenticated, user, logout]);

  // Automatically redirect to login if not authenticated
  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Redirecting to login...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <header style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 2rem',
        borderBottom: '1px solid #e5e7eb',
        background: 'white'
      }}>
        <h1 style={{ margin: 0 }}>ROI Calculator</h1>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <Profile />
          <LogoutButton />
        </div>
      </header>
      <Calculator />
    </div>
  );
}

function App() {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

  console.log('Auth0 Domain:', domain);
  console.log('Auth0 Client ID:', clientId);

  if (!domain || !clientId) {
    return (
      <div className="App">
        <h1>ROI Calculator</h1>
        <p style={{ color: 'red' }}>
          ⚠️ Auth0 configuration missing. Check environment variables.
        </p>
      </div>
    );
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <AppContent />
    </Auth0Provider>
  );
}

export default App;